export default __webpack_public_path__ + "static/media/home-creative-portfolio-img-03.03401c3c.jpg";